<template>
  <div class="notice-popup" v-if="jpNoticeVisible">
    <div class="popup-shadow" @click="hideJpNoticePopup"></div>
    <div class="popup-container">
      <div class="title">{{ titleText }}</div>
      <div class="tips-content" v-html="content"></div>
      <div class="popup-close" @click="hideJpNoticePopup"></div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';

export default {
  name: 'JpNoticePopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      jpNoticeVisible: false,
      content: '',
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      letter: state => state.letter,
      gameId: state => state.gameId
    }),
    ...mapGetters(['gameInfoConfig']),
    titleText() {
      return 'VIPポイント機能アップデートのお知らせ';
    }
  },
  methods: {
    hideJpNoticePopup() {
      this.jpNoticeVisible = false;
    },
    showJpNoticePopup() {
      let JP_NOTICE_POPUP_STATE = 'JP_NOTICE_POPUP_STATE';
      if (!+globalConfig.getCookie(JP_NOTICE_POPUP_STATE)) {
        this.content = '<span style="line-height: 70px;">親愛なる旦那様：</span><br />\t\nいつも本サイトをご利用いただき、誠にありがとうございます。<br />\nVIPポイント機能アップデートのため、クーポン交換機能が利用できなくなります。なお、まだ有効期間内のクーポンをお持ちの方はクーポン使用可能です。<br />\n*注意*クーポン機能は9月21日よりご利用できなくなります。<br />\n今後、新VIPポイント機能の更新も予定しております。ぜひご期待くださいませ。<br />\n引き続き「日替わり内室」をよろしくお願いいたします。';
        this.jpNoticeVisible = true;
        // 3s后设置cookie, 避免刷新误触发
        setTimeout(() => {
          globalConfig.setCookie(JP_NOTICE_POPUP_STATE, 1);
        }, 3000);
      }
    }
  },
  mounted() {
    this.showJpNoticePopup();
  },
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';

.notice-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
}

.popup-shadow {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.popup-container {
  position: relative;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;
  width: 565px !important;
}

.title {
  text-align: center;
  height: 87px;
  line-height: 87px;
  font-size: 22px;
  @include g-popup-title();
  margin: 0;
  border-radius: 10px;
  font-weight: bold;
}

.tips-content {
  display: block;
  box-sizing: border-box;
  padding: 0 20px 20px;
  line-height: 30px;
  font-size: 18px;
  clear: both;
  margin: 0 auto;
  width: 100%;
  height: auto;
  overflow-y: auto;
  max-height: 500px;
  text-align: left;
}

.popup-close {
  position: absolute;
  right: 32px;
  top: 27px;
  background: url($tmslgImg + 'close.png') no-repeat;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

@media screen and (orientation: landscape) {
  .popup-container {
    width: $landscapePopupWidth;
  }

  .title {
    height: 61px;
    line-height: 61px;
    font-size: 22px;
  }

  .popup-close {
    position: absolute;
    right: 15px;
    top: 19px;
    background: url($tmslgImg + 'close.png') no-repeat;
    width: 23px;
    height: 23px;
    cursor: pointer;
    background-size: cover;
  }
}
</style>
